import PrivacyPolicy from "../Pages/Other/PrivacyPolicy";
import SupportPage from "../Pages/Other/SupportPage";
import TermsAndConditions from "../Pages/Other/TermsAndConditions";

const OG_DESCRIPTION =
  "Access hundreds of exclusive deals and discounts from your favorite local businesses. Start saving today!";

const OG_DESCRIPTION_RESOURCES =
  "How to use guide, Free Resources, communityx, buy local, hyper local marketplace, community marketplace";

const OG_IMAGE =
  "https://customer.communityx.digital/static/media/ogImage.ffae56f6b37405a0dcb6.png";

const PublicPageOpen = [
  {
    path: "/support",
    component: SupportPage,
    pageTitle: "CommunityX Digital| Resources",
    pageDescription: OG_DESCRIPTION_RESOURCES,
    pageImage: OG_IMAGE,
  },
  {
    path: "/privacy-policy",
    component: PrivacyPolicy,
    pageTitle: "CommunityX Digital| Privacy Policy",
    pageDescription: OG_DESCRIPTION,
    pageImage: OG_IMAGE,
  },
  {
    path: "/terms-and-conditions",
    component: TermsAndConditions,
    pageTitle: "CommunityX Digital| Terms and Conditions",
    pageDescription: OG_DESCRIPTION,
    pageImage: OG_IMAGE,
  },
];

export default PublicPageOpen;
